// import 'rxjs/add/operator/catch';
// import 'rxjs/add/operator/map';

import { Injectable } from '@angular/core';
import { ApplicationHttpClient } from 'app/application-http-client';
import { Observable } from 'rxjs';

import { Pushtodms } from '../../../pushtodms/home/pushtodms';

@Injectable()
export class PushtoDmsServiceV1 {
  // this class must be renamed to PushtoDmsService upon the existent is removed
  private apiUrl = '/push/dms';

  getPushToDmsInfo(customerId: string, eventId: string): Observable<Pushtodms> {
    const params = ApplicationHttpClient.toHttpParams({
      customerId: customerId,
      eventId: eventId
    });

    return this.http.get(this.apiUrl, { params: params, errorNotification: true });
  }

  updatePushToDmsInfo(params: Object): Observable<Pushtodms> {
    return this.http.post(this.apiUrl, params);
  }

  resubmitPushToDmsInfo(params: Object): Observable<string> {
    return this.http.put(this.apiUrl, params);
  }

  getDmsName(storeKey: number): Observable<any> {
    const params = ApplicationHttpClient.toHttpParams({
      storeKey: storeKey
    });

    return this.http.get(`${this.apiUrl}/dmsname`, { params: params, errorNotification: true });
  }

  getEventData(opportunityId: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/${opportunityId}/event`);
  }

  constructor(private http: ApplicationHttpClient) {}
}
